import React from "react";
import ErrorBoundary from "../ErrorBoundary";
import Llama from "../Llama";
import assets from "../Llama/assets.json";

const Sidebar = ({ className, llamaClassName, onSelect, ...props}) => {
    const ref = React.useRef();
    return (
        <ErrorBoundary componentName="LlamaSidebar">
        <div ref={ref} className={className}>
            {assets.map(({ name }) => {
                return <Llama key={name} scale={2} type={name} className={llamaClassName} onClick={()=>onSelect && onSelect(name)} {...props} />
            })}
        </div>
        </ErrorBoundary>
    );
};

export default Sidebar;
